import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export default function LogoMain() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="h5" sx={{ fontWeight: 800, color: 'primary.main', letterSpacing: '-0.5px', lineHeight: 1.1 }}>
        Clinic Management
      </Typography>
      <Typography variant="caption" sx={{ fontWeight: 700, color: 'text.secondary', fontSize: '0.65rem', letterSpacing: '0.3px', textTransform: 'uppercase' }}>
        by Webelevate Technologies
      </Typography>
    </Box>
  );
}
